Ext.define('SA.VectorMapExportWindow', {
    alias: 'widget.vector-map-export-window',
    extend: 'Ext.Container',

    autoShow: true,
    cls: 'sa-map-export sa-map-export-layout',
    floating: true,
    modal: true,

    layout: {
        align: 'stretch',
        type: 'vbox'
    },

    initComponent() {
        var map = this.map,
            details = this.details,
            isInches = details.getUnits() === 'inches';

        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-map-export-header',

                items: [
                    {
                        xtype: 'component',
                        html: 'Export Map \u2013 Layout'
                    }, {
                        xtype: 'close-button'
                    }
                ]
            }, {
                xtype: 'container',
                flex: 1,
                padding: '9 14',

                layout: {
                    align: 'stretch',
                    type: 'hbox'
                },

                items: [
                    {
                        xtype: 'container',
                        itemId: 'layoutOptions',
                        width: 277,

                        items: [
                            {
                                xtype: 'component',
                                cls: 'sa-map-export-instructions',
                                itemId: 'instructions',
                                margin: '0 14 6 0',
                                width: 263,

                                html: [
                                    '<div class="sa-map-export-instructions-title">',
                                        '<svg class="sa-map-export-step-icon">',
                                            '<use href="#sa-icon-step-2"></use>',
                                        '</svg>',
                                        'Stage 2 of 3 \u2013 Layout',
                                    '</div>',
                                    '<div>The options below allow you to select the page size. You can then position the map within the page.<br><br>Overlays, such as a legend, can also be added at this point.</div>'
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-map-export-layout-row',
                                margin: '12 0 0',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-map-export-layout-row-label',
                                        html: 'Page Size:'
                                    }, {
                                        xtype: 'sa-radio-group',
                                        itemId: 'pageSizeRadioGroup',

                                        items: [
                                            {value: 'inches', boxLabel: 'In Inches', checked: isInches},
                                            {value: 'pixels', boxLabel: 'In Pixels', checked: !isInches}
                                        ]
                                    }
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-map-export-layout-row',
                                margin: '15 0 0',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-map-export-layout-row-label sa-map-export-standard-sizes-label',
                                        html: 'Standard Sizes:'
                                    }, {
                                        xtype: 'export-standard-sizes-combo',
                                        details,
                                        width: 110
                                    }
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-map-export-layout-row',
                                margin: '17 0 0',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-map-export-layout-row-label',
                                        html: 'Orientation:'
                                    }, {
                                        xtype: 'export-orientation-radiogroup',
                                        details
                                    }
                                ]
                            }, {
                                xtype: 'container',
                                cls: 'sa-export-page-dimensions sa-map-export-layout-units-row',
                                height: 60,
                                layout: 'absolute',
                                margin: '18 0 0',

                                items: [
                                    {
                                        xtype: 'export-size-field',
                                        details,
                                        fieldLabel: 'Width',
                                        itemId: 'widthExportSizeField',
                                        labelWidth: 130,
                                        name: 'width',
                                        value: 11,
                                        width: 240,
                                        x: 0,
                                        y: 0
                                    }, {
                                        xtype: 'export-size-field',
                                        details,
                                        fieldLabel: 'Height',
                                        itemId: 'heightExportSizeField',
                                        labelWidth: 130,
                                        name: 'height',
                                        value: 8.5,
                                        width: 240,
                                        x: 0,
                                        y: 31
                                    }, {
                                        xtype: 'component',
                                        cls: 'sa-export-aspect-ratio-button sa-export-aspect-ratio-button-locked x-unselectable',
                                        itemId: 'lock-aspect-ratio-button',
                                        locked: true,
                                        x: 115,
                                        y: 15,

                                        html: [
                                            '<div class="sa-export-aspect-ratio-button-target" title="Lock aspect ratio">',
                                                '<svg class="sa-export-aspect-ratio-button-svg-locked"><use href="#sa-icon-lock-locked"></use></svg>',
                                                '<svg class="sa-export-aspect-ratio-button-svg-unlocked"><use href="#sa-icon-lock-unlocked"></use></svg>',
                                            '</div>'
                                        ],

                                        listeners: {
                                            el: {
                                                delegate: '.sa-export-aspect-ratio-button-target',

                                                click() {
                                                    var cmp = Ext.getCmp(this.id);

                                                    cmp.locked = !cmp.locked;

                                                    cmp.ifCls(cmp.locked, 'sa-export-aspect-ratio-button-locked');
                                                }
                                            }
                                        },

                                        isLocked() {
                                            return this.locked;
                                        }
                                    }
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-map-export-layout-checkbox-row',
                                margin: '22 0 0',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-map-export-layout-row-label',
                                        html: 'Legend:'
                                    }, {
                                        xtype: 'sa-checkbox',
                                        checked: details.getLegend().isVisible(),
                                        disabled: !map.getAttribute() && !map.getBusinessSearch(),
                                        itemId: 'legend'
                                    }
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-map-export-layout-row',
                                margin: '9 0 0',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-map-export-layout-row-label',
                                        html: 'Legend Theme:',
                                        itemId: 'legendThemeRadioGroupLabel'
                                    }, {
                                        xtype: 'sa-radio-group',
                                        itemId: 'legendTheme',

                                        items: [
                                            {value: 'light', boxLabel: 'Light', checked: true},
                                            {value: 'dark', boxLabel: 'Dark'}
                                        ]
                                    }
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-map-export-layout-checkbox-row',
                                margin: '16 0 0',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-map-export-layout-row-label',
                                        html: 'Scale Bar:'
                                    }, {
                                        xtype: 'sa-checkbox',
                                        checked: details.getScaleBar().isVisible(),
                                        itemId: 'scaleBar'
                                    }
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-map-export-layout-checkbox-row',
                                margin: '8 0 0',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-map-export-layout-row-label',
                                        html: 'Inset Map:'
                                    }, {
                                        xtype: 'sa-checkbox',
                                        checked: details.getInsetMap().isVisible(),
                                        itemId: 'insetMap'
                                    }
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-map-export-layout-checkbox-row',
                                margin: '8 0 14',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-map-export-layout-row-label',
                                        html: 'North Arrow:'
                                    }, {
                                        xtype: 'sa-checkbox',
                                        checked: details.getNorthArrow().isVisible(),
                                        itemId: 'northArrow'
                                    }
                                ]
                            }
                        ],

                        layout: {
                            align: 'stretch',
                            type: 'vbox'
                        }
                    }, {
                        xtype: 'container',
                        flex: 1,

                        items: [
                            {
                                xtype: 'vector-map-export-preview',
                                details,
                                flex: 1,
                                map
                            }
                        ],

                        layout: {
                            align: 'stretch',
                            type: 'vbox'
                        }
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-map-export-footer',

                items: [
                    {
                        xtype: 'sa-button',
                        cls: 'sa-map-export-add-text-label-button',
                        itemId: 'addTextLabel',
                        text: 'Add Text Label…'
                    }, {
                        xtype: 'sa-button',
                        itemId: 'returnToCroppingButton',
                        text: 'Return to Cropping'
                    }, {
                        xtype: 'sa-button',
                        itemId: 'continueToExportButton',
                        text: 'Continue to Export',
                        ui: 'primary'
                    }, {
                        xtype: 'sa-button',
                        itemId: 'cancelButton',
                        text: 'Cancel'
                    }
                ]
            }
        ];

        this.callParent();

        this.addTextLabel = this.down('#addTextLabel');
        this.cancelButton = this.down('#cancelButton');
        this.continueToExportButton = this.down('#continueToExportButton');
        this.exportStandardSizesCombo = this.down('export-standard-sizes-combo');
        this.heightExportSizeField = this.down('#heightExportSizeField');
        this.insetMapCheckBox = this.down('#insetMap');
        this.instructions = this.down('#instructions');
        this.legendCheckBox = this.down('#legend');
        this.legendThemeRadioGroup = this.down('#legendTheme');
        this.northArrowCheckBox = this.down('#northArrow');
        this.orientationRadioGroup = this.down('export-orientation-radiogroup');
        this.pageSizeRadioGroup = this.down('#pageSizeRadioGroup');
        this.previewPage = this.down('vector-map-export-preview-page');
        this.returnToCroppingButton = this.down('#returnToCroppingButton');
        this.scaleBarCheckBox = this.down('#scaleBar');
        this.widthExportSizeField = this.down('#widthExportSizeField');

        this.refreshSizeAndCenter();
    },

    afterHide() {
        this.query('[floating]').forEach(item => {
            if (item.isVisible()) {
                item.hide();
            }
        });

        this.callParent(arguments);
    },

    beforeDestroy() {
        this.callParent();

        this.mun(SA.Viewport, 'resize', this.onViewportResize, this);
    },

    initEvents() {
        this.callParent();

        this.mon(SA.Viewport, 'resize', this.onViewportResize, this);

        this.addTextLabel.on('click', button => this.fireEvent('click:addTextLabel', button));
        this.cancelButton.on('click', () => this.destroy());
        this.continueToExportButton.on('click', button => this.fireEvent('click:continue', button));
        this.exportStandardSizesCombo.on('change', combo => this.fireEvent('change:standardSize', combo));
        this.heightExportSizeField.on('inputblur', field => this.fireEvent('inputblur:height', field));
        this.insetMapCheckBox.on('change', checkBox => this.fireEvent('change:insetMap', checkBox));
        this.legendCheckBox.on('change', checkBox => this.fireEvent('change:legend', checkBox));
        this.legendThemeRadioGroup.on('change', (radioGroup, value) => this.fireEvent('change:legendTheme', radioGroup, value));
        this.northArrowCheckBox.on('change', checkBox => this.fireEvent('change:northArrow', checkBox));
        this.orientationRadioGroup.on('change', (radioGroup, value) => this.fireEvent('change:orientation', radioGroup, value));
        this.pageSizeRadioGroup.on('change', (radioGroup, value) => this.fireEvent('change:pageSize', radioGroup, value));
        this.previewPage.on('click:overlay', overlay => this.fireEvent('click:overlay', overlay));
        this.previewPage.on('click:textLabel', textLabel => this.fireEvent('click:textLabel', textLabel));
        this.previewPage.on('move:textLabel', textLabel => this.fireEvent('move:textLabel', textLabel));
        this.previewPage.on('resize:textLabel', textLabel => this.fireEvent('resize:textLabel', textLabel));
        this.previewPage.on('show:overlay', overlay => this.fireEvent('show:overlay', overlay));
        this.previewPage.on('usermove:overlay', overlay => this.fireEvent('usermove:overlay', overlay));
        this.previewPage.on('userresize:overlay', overlay => this.fireEvent('userresize:overlay', overlay));
        this.returnToCroppingButton.on('click', button => this.fireEvent('click:returnToCropping', button));
        this.scaleBarCheckBox.on('change', checkBox => this.fireEvent('change:scaleBar', checkBox));
        this.widthExportSizeField.on('inputblur', field => this.fireEvent('inputblur:width', field));
    },

    onShow() {
        this.callParent();

        this.refreshSizeAndCenter();
    },

    onViewportResize() {
        if (!this.isVisible()) {
            return;
        }

        this.refreshSizeAndCenter();
    },

    refreshPreviewPage() {
        this.previewPage.refresh();
    },

    refreshSizeAndCenter() {
        var body = Ext.getBody(),
            instructions = this.instructions,
            El = Ext.dom.Element,
            constrain = Ext.Number.constrain,
            maxHeight = 777,
            width = constrain(El.getViewportWidth() - 20, 650, 1200),
            height = constrain(El.getViewportHeight() - 20, 606, maxHeight),
            xy;

        Ext.suspendLayouts();

        instructions.setVisible(height === maxHeight);

        this.setWidth(width);
        this.setHeight(height);

        Ext.resumeLayouts(true);

        if (this.rendered) {
            xy = this.getAlignToXY(body, 'c-c?');

            this.setPagePosition(xy);
        }
    }
});